import Vue from 'vue'
import { dateFormat } from '@/utils/formatters';

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})


Vue.filter("date", value => {
  if(value === undefined) return "";
  return dateFormat(new Date(value))
})
